/**
 * Normalizes a WordPress AJAX/REST URL to prevent protocol mismatches (Mixed Content)
 * and CORS issues, especially when accessed via HTTPS/SSL proxies or Local WP Live Links.
 */
export function normalizeAjaxUrl(url: string): string {
  if (!url) return 'https://shuddhoshiksha.com/wp-admin/admin-ajax.php';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const parsedUrl = new URL(url);
      if (parsedUrl.host === window.location.host) {
        return parsedUrl.pathname + parsedUrl.search;
      } else {
        return url.replace(/^https?:/, window.location.protocol);
      }
    } catch (e) {
      // Fallback
    }
  }
  return url;
}
